/**
 * Соседние главы для пейджера / предзагрузки (та же логика, что prev/next в ChapterView).
 * @returns {{ prev: { bookId: number, chapter: number } | null, next: { bookId: number, chapter: number } | null }}
 */
export function getChapterNeighbors({
  bookId,
  chapter,
  totalChapters,
  books = [],
}) {
  const currentBookId = parseInt(bookId, 10);
  const currentChapter = parseInt(chapter, 10);
  const total = parseInt(totalChapters, 10) || 0;

  if (!Number.isFinite(currentBookId) || !Number.isFinite(currentChapter)) {
    return { prev: null, next: null };
  }

  const bookIdx = books.findIndex((b) => parseInt(b.id, 10) === currentBookId);
  const previousBook = bookIdx > 0 ? books[bookIdx - 1] : null;
  const nextBook = bookIdx !== -1 && bookIdx < books.length - 1 ? books[bookIdx + 1] : null;

  let prev = null;
  if (currentChapter > 1) {
    prev = { bookId: currentBookId, chapter: currentChapter - 1 };
  } else if (previousBook) {
    const lastChapter = parseInt(previousBook.chapters ?? previousBook.totalChapters ?? 1, 10);
    prev = { bookId: parseInt(previousBook.id, 10), chapter: lastChapter };
  }

  let next = null;
  if (total > 0 && currentChapter < total) {
    next = { bookId: currentBookId, chapter: currentChapter + 1 };
  } else if (nextBook) {
    next = { bookId: parseInt(nextBook.id, 10), chapter: 1 };
  }

  return { prev, next };
}
